import { headerSlice } from './slice';

export const { set, clear } = headerSlice.actions;

export { headerSlice };
